import Button, {
  ButtonTypes,
  ButtonDefaultType,
} from './Button';

export default Button;

export {
  ButtonTypes,
  ButtonDefaultType,
};
